module.exports = "/img/ui-guide.de2cd22e.gif";